<template>
	<b-modal
		size="lg"
		:title="`${$t('transportServiceChangeStatus.title')}: ${statusLabel}`"
		v-model="showModal"
	>
		<FilesRelated
			:model-id="transportServiceId"
			model-reference="transport-services"
			unable-delete
			:cols="3"
			:file-keys="[
				{
					label:'Evidencias',
					keyName: 'changeStatusEvidence[]',
				},
			]"
			:counter.sync="counterFiles"
		/>
		<b-form-group :label="$t('transportServiceChangeStatus.note')">
			<b-textarea v-model="note" />
		</b-form-group>
		<template #modal-footer="{ close }">
			<b-button :disabled="loading" @click="close()" type="button" class="float-right">{{$t('transportServiceChangeStatus.btnCancel')}}</b-button>
			<b-button :disabled="!enableChangeStatus" @click="doChangeStatus" type="button" variant="primary" class="float-right">
				<span v-if="!loading">{{$t('transportServiceChangeStatus.btnUpdate')}}</span>
				<span v-else><b-spinner small></b-spinner> {{$t('transportServiceChangeStatus.btnUpdateProcess')}}...</span>
			</b-button>
		</template>
	</b-modal>
</template>

<script>
import FilesRelated from '@/components/helpers/FilesRelated'

export default {
	props: {
		status : {
			type: String,
			required: true,
		},
		transportServiceId : {
			type: Number,
			required: true,
		},
		show : {
			type: Boolean,
			required: true,
		},
		requireFiles : {
			type: Boolean,
			required: false,
			default: false,
		}
	},
	components: {
		FilesRelated
	},
	data(){
		return {
			loading : false,
			note : '',
			counterFiles: [],
		}
	},
	methods : {
		doChangeStatus(){
			this.loading = true
			this.$root.api.post(`/transport-services/change-status/${this.transportServiceId}`,{ note:this.note,status:this.status }).then( () => {
				this.$root.showAlert('Servicio actualizado con éxito')
				this.loading = false
				this.note = ''
				this.showModal = false
				this.$emit('onUpdate')
			}).catch(this.$root.handleRequestError);
		},
	},
	computed : {
		enableChangeStatus(){
			return (!this.requireFiles || (this.requireFiles && this.hasFiles)) && !!this.note
		},
		hasFiles(){
			return this.counterFiles.find(counter => counter.key === 'changeStatusEvidence[]' && counter.count > 0) !== undefined
		},
		statusLabel(){
			return this.$t(`transportServiceStatus.${this.status}`);
		},
		showModal : {
			get(){
				return this.show
			},
			set(val){
				this.$emit('update:show',val)
			}
		}
	}
}
</script>
